import React from 'react';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {getFactionConfig} from '../../../utils/factions/getFactionConfig';
import {getFactionIconPath} from '../../../utils/factions/getFactionIconPath';
import './TutorialMissionsPage.css';

/**
 * Блок награды миссии/задания: заголовок («Награда:» или свой) и под ним
 * крупная иконка (премиум / сундук / фракция) с названием.
 *
 * Используется и списком глав обучения (еще не полученная награда), и
 * страницей «Задания» — в том числе для уже полученных наград
 * (title={'Получено:'})
 */
export const MissionRewardBadge = ({reward, title = 'Награда:'}) => {
  if (!reward) {
    return null;
  }

  let iconSrc = null;
  let iconClassName = 'tutorial-missions-page_reward-icon';
  let nameClassName = 'tutorial-missions-page_reward-name';
  let rewardAlt = null;
  let rewardName = null;

  if (reward.type === 'premium') {
    iconSrc = '/img/icons/premium.png';
    nameClassName += ' tutorial-missions-page_reward-name_coins';
    rewardAlt = `${reward.days} дня Премиума`;
    rewardName = rewardAlt;
  } else if (reward.type === 'chest') {
    // Награда может быть пачкой сундуков (reward.count) — тогда к названию
    // приписываем количество: «Серебряный сундук ×10»
    const count = reward.count && reward.count > 1 ? reward.count : null;
    iconSrc = getChestIconPath(reward.chestId);
    iconClassName += ' tutorial-missions-page_reward-icon_chest';
    nameClassName += ' tutorial-missions-page_reward-name_coins';
    rewardAlt = getChestDisplayName(reward.chestId) + (count ? ` ×${count}` : '');
    rewardName = rewardAlt;
  } else if (reward.type === 'faction') {
    const factionConfig = getFactionConfig(reward.factionId);
    const factionName = factionConfig?.name || reward.factionId;
    iconSrc = getFactionIconPath(reward.factionId);
    nameClassName += ' tutorial-missions-page_reward-name_white';
    rewardAlt = `Доступ к фракции ${factionName}`;
    rewardName = (
      <>Доступ к фракции <span className={'text-crystals'}>{factionName}</span></>
    );
  } else {
    return null;
  }

  return (
    <span className={'tutorial-missions-page_reward'}>
      <span className={'tutorial-missions-page_reward-title'}>{title}</span>
      <span className={'tutorial-missions-page_reward-content'}>
        <img className={iconClassName} src={iconSrc} alt={rewardAlt}/>
        <span className={nameClassName}>{rewardName}</span>
      </span>
    </span>
  );
};

export default MissionRewardBadge;
